"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STEP_TYPE_KEYS = exports.STEP_TYPES = void 0;
const Basic_1 = require("./Basic");
const Click_1 = require("./Click");
const Input_1 = require("./Input");
const Wait_1 = require("./Wait");
exports.STEP_TYPES = {
    Basic: Basic_1.Basic,
    Click: Click_1.Click,
    Input: Input_1.Input,
    Wait: Wait_1.Wait,
};
exports.STEP_TYPE_KEYS = Object.keys(exports.STEP_TYPES);
//# sourceMappingURL=index.js.map